import React from 'react';
import { Button, ModuleContainer } from '../../core/components';
import { TranslationService } from '../../core/services';
import ErrorImg from '../../assets/images/error.svg';
import styles from './ErrorRoute.module.scss';

const ErrorRoute = () => {
  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-6">
          <ModuleContainer classNames={styles.wrapper}>
            <ModuleContainer.Header title={TranslationService.translate('Error')} />

            <ModuleContainer.Body>
              <p>{TranslationService.translate('ErrorSthWentWrong')}</p>

              <img alt="" src={ErrorImg} className={styles.errorImg} />

              <Button variant={Button.Variants.Primary}>
                {TranslationService.translate('ReturnToMainPage')}
              </Button>
            </ModuleContainer.Body>
          </ModuleContainer>
        </div>
      </div>
    </div>
  );
};

export default ErrorRoute;
